import { render } from "./ViewCompetitionView.vue?vue&type=template&id=35ed7c24&ts=true"
import script from "./ViewCompetitionView.vue?vue&type=script&lang=ts"
export * from "./ViewCompetitionView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__